/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDeleteVacancyModel,
  IDeleteVacancyRequest,
  IMappers,
  IDeleteVacancyResponse,
  IDeleteVacancyResponseError,
  TDeleteVacancyResponse,
} from './types';

const defaultConfig: TDeleteVacancyModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'vacancies',
  pathApi: '/v1/delete-vacancy/',
  hostType: 'api',
} as TDeleteVacancyModel;

function createDeleteVacancyModel(parameters: IDeleteVacancyRequest): TDeleteVacancyModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDeleteVacancyOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IDeleteVacancyRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchDeleteVacancy<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDeleteVacancyOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TDeleteVacancyResponse> {
  const { response, statusCode } = await httpApi.fetch(createDeleteVacancyModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IDeleteVacancyResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IDeleteVacancyResponseError);
    }
  }

  return { response, statusCode } as TDeleteVacancyResponse;
}

export { defaultConfig, createDeleteVacancyModel, fetchDeleteVacancy };
